module.exports = __webpack_public_path__ + "img/logo.48bd83d6.jpg";